"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
export function ProposalChoiceCard(t0) {
  const $ = _c(6);
  const {
    active,
    children,
    onClick
  } = t0;
  const t1 = active ? "border-primary-300 bg-transparent" : "hover:border-primary-300";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("text-base flex h-full w-full max-w-full flex-col items-center justify-center gap-4 rounded-lg border border-transparent bg-gray-350 px-2 py-8 max-sm:px-1 max-sm:text-[13px] text-center font-medium transition-[border-color,background-color,box-shadow] duration-220 ease-out will-change-transform", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== onClick || $[4] !== t2) {
    t3 = <button className={t2} data-proposal-animate={true} onClick={onClick} type="button">{children}</button>;
    $[2] = children;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}